import Button from 'atoms/Button';

import Modal from 'atoms/Modal';
import { colors } from 'constants/colors';
import ColoredDot from 'layout/atoms/ColoredDot';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/index';
import { setProjectColor } from 'store/projectsThunks';
import { selectProject } from 'store/workspaceSlice';
import styles from './Project.module.scss';

export const ChangeColor = (props: {
    opened: boolean;
    workspaceId: string;
    projectId: string;
    handleModalClose: () => void;
}) => {
    const dispatch = useDispatch<AppDispatch>();
    const project = useSelector((state: RootState) =>
        selectProject(state, props.projectId)
    );

    const handleColorChange = (color: string) => {
        dispatch(
            setProjectColor({
                projectId: props.projectId,
                command: {
                    workspaceId: props.workspaceId,
                    color: color,
                },
            })
        );
    };

    return (
        <Modal open={props.opened} size="s" onClose={props.handleModalClose}>
            <header>
                <h2>Change color</h2>
            </header>
            <main className={styles.colorsList}>
                {colors.map((color: string) => (
                    <Button
                        key={color}
                        theme={project.color === color ? 'plain' : 'blank'}
                        shape="square"
                        onClick={() => handleColorChange(color)}
                    >
                        <ColoredDot color={color} />
                    </Button>
                ))}
            </main>
            <footer>
                <Button theme="plain" onClick={props.handleModalClose}>
                    <span>Close</span>
                </Button>
            </footer>
        </Modal>
    );
};
